"use client";

import { c as _c } from "react/compiler-runtime";
import { useContentfulInspectorMode } from "@contentful/live-preview/react";
import Image from "next/image";
import { isAsset, isEntry } from "@/lib/contentful/guards";
import { cn } from "@/lib/utils";
import type { TypeGalleryImage } from "@/types/contentful/generated";
import { ContentfulHelper } from "@/utils/ContentfulHelper";
import GalleryCardWrapper from "./GalleryCardWrapper";
type GalleryImageEntry = TypeGalleryImage<undefined, string>;
interface Props {
  entry: GalleryImageEntry;
  isFullWidth?: boolean;
}
function resolveImage(image: GalleryImageEntry["fields"]["image"]) {
  const asset = isAsset(image) ? image : null;
  return asset ? ContentfulHelper.parseContentfulContentImage(asset) : null;
}
function resolveHref(linkType: string | undefined, externalLink: string | undefined, internalLink: GalleryImageEntry["fields"]["internalLink"]): string | null {
  if (linkType === "External") return externalLink ?? null;
  if (linkType === "Internal") {
    const page = isEntry(internalLink) ? internalLink : null;
    return page ? `/${page.fields.slug}` : null;
  }
  return null;
}
export default function GalleryImageCard(t0) {
  const $ = _c(29);
  const {
    entry,
    isFullWidth: t1
  } = t0;
  const isFullWidth = t1 === undefined ? false : t1;
  const {
    image,
    heading,
    subheading,
    linkType,
    externalLink,
    internalLink,
    isNewTab
  } = entry.fields;
  const entryId = entry.sys.id;
  const inspectorProps = useContentfulInspectorMode();
  let t2;
  if ($[0] !== image) {
    t2 = resolveImage(image);
    $[0] = image;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const contentImage = t2;
  let t3;
  if ($[2] !== externalLink || $[3] !== internalLink || $[4] !== linkType) {
    t3 = resolveHref(linkType, externalLink, internalLink);
    $[2] = externalLink;
    $[3] = internalLink;
    $[4] = linkType;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const href = t3;
  if (!contentImage) {
    return null;
  }
  const t4 = isFullWidth ? "aspect-square md:aspect-2/1" : "aspect-square";
  let t5;
  if ($[6] !== t4) {
    t5 = cn("relative w-full", t4);
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== entryId || $[9] !== inspectorProps) {
    t6 = inspectorProps({
      entryId,
      fieldId: "image"
    });
    $[8] = entryId;
    $[9] = inspectorProps;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = isFullWidth ? "100vw" : "(min-width: 768px) 50vw, 100vw";
  let t8;
  if ($[11] !== contentImage.alt || $[12] !== contentImage.src || $[13] !== t7) {
    t8 = <Image src={contentImage.src} alt={contentImage.alt} fill={true} className="object-cover" sizes={t7} />;
    $[11] = contentImage.alt;
    $[12] = contentImage.src;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t5 || $[16] !== t6 || $[17] !== t8) {
    t9 = <div className={t5} {...t6}>{t8}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== heading || $[20] !== subheading) {
    t10 = (heading ?? subheading) && <div className="flex flex-1 flex-col items-center justify-start gap-2 px-4 py-3">{heading && <h3 className="heading-lg text-center">{heading}</h3>}{subheading && <p className="text-center text-base font-normal leading-normal">{subheading}</p>}</div>;
    $[19] = heading;
    $[20] = subheading;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t9) {
    t11 = <div className="flex h-full flex-col overflow-hidden rounded-lg shadow-md md:flex-col-reverse">{t9}{t10}</div>;
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== href || $[26] !== isNewTab || $[27] !== t11) {
    t12 = <GalleryCardWrapper href={href} isNewTab={isNewTab}>{t11}</GalleryCardWrapper>;
    $[25] = href;
    $[26] = isNewTab;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
}